import { render, staticRenderFns } from "./AccettazioneSsnRicettaComponent.vue?vue&type=template&id=c264b2be"
import script from "./AccettazioneSsnRicettaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnRicettaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports